var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoComment = function SvgIcoComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M0 12.999a1 1 0 0 0 1 1h10v3a1 1 0 0 0 1.625.78L17.35 14H21a1 1 0 0 0 1-1v-12A1 1 0 0 0 21 0H1a1 1 0 0 0-1 1zm7-2H4a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2m5 0h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2m3 0h3a1 1 0 0 0 0-2h-3a1 1 0 1 0 0 2",
    clipRule: "evenodd"
  })));
};
export default SvgIcoComment;